import listBodyItem from './list__body-item';
export default listBodyItem;